import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const tlsProfileTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'TLS Profile',
  key: 'tlsProfile',
  main: {
    metadata: {
      layout: {
        rows: [
          ['id'],
          ['catype', 'keyalgorithm'],
          ['litype', 'aftype', '$empty'],
          ['name', 'description', 'intfType'],
          ['sni', 'tlsVersion', 'tlsType'],
          ['authenType', 'depth', 'hostname'],
          ['cipherFile', '$empty', '$empty'],
          ['certificate', '$empty', '$empty'],
          ['certificateFile', 'certificateAuthority', 'certificateDirectory'],
          ['privateKey', '$empty', '$empty'],
          ['privateKeyFile', 'passphrase', '$empty'],
          ['xccaCertParam', '$empty', '$empty'],
          ['commonName', 'san', '$empty'],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      catype: {
        label: 'Cert Type',
        type: 'select',
        initial: 'SELFSIGNED',
        options: [
          {
            label: 'Self-Signed',
            value: 'SELFSIGNED',
          },
          {
            label: 'XCCA',
            value: 'XCCA',
          }
        ],
      },
      name: {
        label: 'TLS Profile ID',
        hintMessage: 'Max 16 characters with no spaces',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 16,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
      description: {
        label: 'Description',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 256,
            },
          ],
        },
      },
      intfType: {
        label: 'Interface Type',
        type: 'select',
        initial: 'HTTPS',
        options: [
          {
            label: 'HTTPS',
            value: 'HTTPS',
          },
          {
            label: 'FTPS',
            value: 'FTPS',
          },
          {
            label: 'TLS',
            value: 'TLS',
          },
          {
            label: 'DTLS',
            value: 'DTLS',
          },
        ],
      },
      sni: {
        label: 'Server Name Indication',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 64,
            },
          ],
        },
      },
      tlsVersion: {
        label: 'TLS Version',
        type: 'select',
        initial: 'TLSv1.2',
        options: [
          {
            label: 'SSLv2',
            value: 'SSLv2',
          },
          {
            label: 'SSLv3',
            value: 'SSLv3',
          },
          {
            label: 'TLSv1',
            value: 'TLSv1',
          },
          {
            label: 'TLSv1.1',
            value: 'TLSv1.1',
          },
          {
            label: 'TLSv1.2',
            value: 'TLSv1.2',
          },
          {
            label: 'TLSv1.3',
            value: 'TLSv1.3',
          },
        ],
      },
      tlsType: {
        label: 'TLS Type',
        type: 'radio',
        inline: true,
        initial: 'Server',
        options: [
          {
            label: 'Client',
            value: 'Client',
          },
          {
            label: 'Server',
            value: 'Server',
          },
        ],
      },
      authenType: {
        label: 'Authentication Mode',
        type: 'radio',
        inline: true,
        initial: 'SIMPLE',
        options: [
          {
            label: 'Simple',
            value: 'SIMPLE',
          },
          {
            label: 'Mutual',
            value: 'MUTUAL',
          },
        ],
      },
      depth: {
        label: 'Depth',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 2,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  0,
                  10,
                ],
              ],
              errorMessage: 'Must be between 0 - 10. Please re-enter.',
            },
          ],
        },
      },
      hostname: {
        label: 'Hostname',
        type: 'text',
        disabled: true,
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 164,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
      cipherFile: {
        label: 'Cypher File',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 32,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
      certificateFile: {
        label: 'File Name',
        type: 'text',
        initial: 'server.crt',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 128,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
      certificateAuthority: {
        label: 'CA Certificate File',
        type: 'text',
        initial: 'root_cacert.perm.cert',
        validation: {
          validators: [
            {
              type: 'length',
              length: 128,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
      certificateDirectory: {
        label: 'Directory',
        type: 'text',
        initial: '/usr/share/ssl/certs',
        validation: {
          required: false,
          validators: [
            {
              type: 'length',
              length: 128,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
      privateKeyFile: {
        label: 'File Name',
        type: 'text',
        initial: 'server.key',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 128,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
      passphrase: {
        label: 'Passphrase',
        type: 'password',
        validation: {
          validators: [
            {
              type: 'length',
              length: 32,
            },
            {
              type: 'regexp',
              regexp: [
                'letters',
                'digits',
                'spaces',
                '-_.~!@#$%^*+?',
              ],
              errorMessage: 'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?. Please re-enter.',
            },
          ],
        },
      },
      privateKey: {
        type: 'custom',
        initial: 'Private Key',
        customComponent: 'privateKey',
        className: 'section-label',
      },
      certificate: {
        type: 'custom',
        initial: 'Certificate',
        customComponent: 'certificate',
        className: 'section-label',
      },
      aftype: {
        type: 'select',
        label: 'Access Function Type',
        initial: '',
        hide: 'true',
        options: [
          {
            label: 'Select an AF Type',
            value: '',
          }
        ],
        validation: {
          required: true
        }
      },
      litype: {
        type: 'select',
        label: 'LI Type',
        initial: '',
        hide: 'true',
        options: [
          {
            label: 'Select an LI Type',
            value: '',
          },
          {
            label: 'INI1',
            value: 'INI1',
          },
          {
            label: 'INI2',
            value: 'INI2',
          },
          {
            label: 'INI3',
            value: 'INI3',
          }
        ],
        validation: {
          required: true
        }
      },
      commonName: {
        type: 'text',
        label: 'Common Name',
        initial: '',
        hintMessage: 'CN will default to "[AFTYPE]-[LITYPE]" if empty',
        validation: {
          validators: [
            {
              type: 'length',
              length: 64,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        }
      },
      san: {
        type: 'text',
        label: 'SAN',
        initial: '',
        hintMessage: 'Ex: DNSNAME=example,IPADDRESS=51.51.23.1, etc..',
        validation: {
          validators: [
            {
              type: 'length',
              length: 128,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', ',=-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: ,=-_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        }
      },
      keyalgorithm: {
        type: 'select',
        label: 'Key Algorithm',
        initial: 'RSA_4096',
        hide: 'true',
        options: [
          {
            label: 'RSA 2048',
            value: 'RSA_2048',
          },
          {
            label: 'RSA 4096',
            value: 'RSA_4096',
          },
          {
            label: 'RSA 8192',
            value: 'RSA_8192',
          },
          {
            label: 'ECDSA 256',
            value: 'ECDSA_256',
          },
          {
            label: 'ECDSA 384',
            value: 'ECDSA_384',
          },
          {
            label: 'ECDSA 521',
            value: 'ECDSA_521',
          }
        ]
      },
      xccaCertParam: {
        type: 'custom',
        initial: 'XCCA Cert Attributes',
        customComponent: 'xccaCertParam',
        className: 'section-label',
      },
    },
  },
};
